import React, { useState, useEffect, ChangeEvent } from 'react';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    tableTd: {
      fontSize: '15px',
    },
    textField: {
      width: 130,
    },
    //style for font size
    resize: {
      fontSize: '15px',
    },
  })
);

interface DateInputProps {
  labelCssString?: string;
  label: string;
  labelPosition?: number;
  initialValue: string;
  onDateChange: (value: string) => void;
}

const DateInput: React.FC<DateInputProps> = ({ labelCssString, label, labelPosition, initialValue, onDateChange }) => {
  const [selectedDateTime, setSelectedDateTime] = useState(initialValue);

  const classes = useStyles();

  useEffect(() => {
    if (isValidDateTime(initialValue)) {
      setSelectedDateTime(initialValue);
    }
  }, [initialValue]);

  const handleDateTimeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    console.debug(value);
    setSelectedDateTime(value);
  };

  const isValidDateTime = (value: string) => {
    const minDateTime = new Date('1900-01-01T00:00').getTime();
    const maxDateTime = new Date('2999-12-30T00:00').getTime();
    const selectedDateTime = new Date(value).getTime();
    return selectedDateTime >= minDateTime && selectedDateTime <= maxDateTime;
  };

  return (
    <Box component="span" display="inline-flex" alignItems="center">
      {labelPosition === 1 && <div className={labelCssString ?? classes.tableTd}> {label}</div>}
      <TextField
        type="date"
        id="dateInput"
        value={selectedDateTime}
        inputProps={{ min: '2019-01-01', max: '2999-12-30' }}
        onChange={handleDateTimeChange}
        onBlur={(event) => {
          const value = event.target.value;
          if (isValidDateTime(value)) {
            onDateChange(value);
          } else {
            //console.debug(['reset', selectedDateTimeDef]);
            setSelectedDateTime(initialValue);
          }
        }}
      />
    </Box>
  );
};

export default DateInput;
